/* eslint-disable react/prop-types */

import { useEffect } from "react";
import { Formik, Form as FormikForm } from "formik";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

import MDButton from "components/MDButton";

import Form from "./Form";
import validations from "./schemas/validations";
import formSchema from "./schemas/form";
import initialValues from "./schemas/initialValues";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function Modal({
  open,
  handleClose,
  isEdit = false,
  onSumbit = () => {},
  data = {},
  locations = [],
  timezones = [],
}) {
  const { formId, formField } = formSchema;

  return open ? (
    <BootstrapDialog aria-labelledby="customized-dialog-title" open={open}>
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        {isEdit ? "Edit Device" : "Device Creation"}
      </BootstrapDialogTitle>

      <Formik
        initialValues={initialValues}
        validationSchema={validations}
        enableReinitialize
        onSubmit={(values, formik) => {
          formik.validateForm().then((res) => {
            if (res) {
              onSumbit(values, (err) => {
                console.log(err);
                if (err && err.errors && Array.isArray(err.errors) && err.errors.length) {
                  const formErrors = {};
                  err.errors.forEach((e) => {
                    if (e.key && formField[e.key] && e.error) {
                      formErrors[e.key] = e.error;
                    }
                  });
                  console.log(formErrors);
                  if (Object.keys(formErrors).length) {
                    formik.setErrors(formErrors);
                  }
                }
                formik.setSubmitting(false);
              });
            } else {
              console.log(res);
            }
          });
        }}
      >
        {({ values, errors, touched, isSubmitting, setValues, setFieldValue }) => {
          useEffect(() => {
            if (isEdit && data) {
              setValues({
                ...data,
                profileImage: data.profileImage || false,
                signShift: data.signShift || false,
                collectIP: data.collectIP || false,
              });
            }
          }, [isEdit]);

          return (
            <FormikForm id={formId} autoComplete="new-password">
              <DialogContent dividers style={{ width: 576 }}>
                <Form
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                    setValues,
                    setFieldValue,
                  }}
                  isEdit={isEdit}
                  locations={locations}
                  timezones={timezones}
                />
              </DialogContent>
              <DialogActions>
                <MDButton
                  disabled={isSubmitting}
                  onClick={handleClose}
                  type="button"
                  variant="gradient"
                  color="secondary"
                >
                  Cancel
                </MDButton>
                <MDButton disabled={isSubmitting} type="submit" variant="gradient" color="info">
                  Save
                </MDButton>
              </DialogActions>
            </FormikForm>
          );
        }}
      </Formik>
    </BootstrapDialog>
  ) : null;
}
